import { Action, Dispatch } from 'redux';
import { SET_CONTENT_CHANGED } from './actions';

/**
 * Сбрасываем результат проверки GF компани при изменении урла.
 */
export const createDyMiddleware = () => () => (next: Dispatch) => (action: Action) => {
  if (action.type === 'LOCATION_UPDATE') {
    next(SET_CONTENT_CHANGED(true));
    return next(action);
  }

  return next(action);
};
